import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const CalculatedValueWithIncentivesMonthly = () => {
    const { chartData } = useValuesChartsDataContext();

    const rawData = chartData?.calculatedValueWithIncentivesMonth || [];

    const formattedValues = rawData.map((item) => {
        const value = Number(item.value);
        return isNaN(value) ? 0 : value;
    });

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Valor Calculado Com Incentivos (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            values={formattedValues}
        />
    );
};